window.okeReviewsWidgetOnInit = function() {
    const writeAReviewButton = document.querySelector(".js-okeReviews-writeReview");
    const reviewsControl = document.querySelector(".okeReviews-reviews-controls");
    if (writeAReviewButton) {
        // Insert WAR button into header
        if (writeAReviewButton && reviewsControl) {
            const reviewsControlSelect = reviewsControl.querySelector(".okeReviews-reviews-controls-select");
            reviewsControlSelect.insertAdjacentElement("afterbegin", writeAReviewButton);
        }
    }

    // move aggregate to above navbar
    const aggregate = document.querySelector(".okeReviews.okeReviews--theme .okeReviews-reviewsWidget .okeReviews-reviewsAggregate-side-inner");
    const holder = document.querySelector(".okeReviews-widget-holder");
    holder.classList.add("okeReviews");
    holder.classList.add("okeReviews--theme");
    aggregate && holder.prepend(aggregate);

    // move buttons to the same line as navbar
    moveElement(".okeReviews-reviews-controls", "[data-oke-reviews-nav-bar] .okeReviews", false, document, true, () => {
        const reviewsTab = document.querySelector("#okeReviews-reviews-tab");
        const qaTab = document.querySelector("#okeReviews-qanda-tab");
        reviewsTab.addEventListener("click", () => {
            const reviewsButtons = document.querySelector(".okeReviews-reviews-controls");
            const qaButtons = document.querySelector(".okeReviews-qandaWidget-header-controls");
            reviewsButtons.style.display = "inline-block";
            qaButtons.style.display = "none";
        });
        qaTab.addEventListener("click", () => {
            const reviewsButtons = document.querySelector(".okeReviews-reviews-controls");
            const qaButtons = document.querySelector(".okeReviews-qandaWidget-header-controls");
            reviewsButtons.style.display = "none";
            qaButtons.style.display = "inline-block";
        });
    });

    // restructure reviews on change
    restructureIndividualReviews();
    var okeObserver = new MutationObserver(restructureIndividualReviews);
    okeObserver.observe(document.querySelector(".js-okeReviews-reviews-main"), { childList: true });
};

okeReviewsQandaOnInit = function() {
    // move buttons to the same line as navbar
    moveElement(".okeReviews-qandaWidget-header-controls", "[data-oke-reviews-nav-bar] .okeReviews", false, document, true, () => {
        console.log(111);
        const qaButtons = document.querySelector(".okeReviews-qandaWidget-header-controls");
        qaButtons.style.display = "none";
    });
};

/*
 * Restructure a list of given individual reviews node
 * */
function restructureIndividualReviews(mutationsList) {
    var nodesToRestructure = document.querySelectorAll(".okeReviews-reviews-review");

    for (var i = 0; i < nodesToRestructure.length; ++i) {
        var reviewNode = nodesToRestructure[i];
        // restructure operations to each individual review node

        // move recommendation and helpfulness to same line
        const recommendation = reviewNode.querySelector(".okeReviews-review-recommendation");
        const helpfulness = reviewNode.querySelector(".okeReviews .okeReviews-review-helpful");
        const line = document.createElement("div");
        const reviewPrimaryLeft = reviewNode.querySelector(".okeReviews-review-primary-grid-left");
        line.className = "okeReviews-recommendation-helpfulness";
        recommendation && line.append(recommendation);
        line.append(helpfulness);
        reviewPrimaryLeft.append(line);
    }
}

// needed for moving navbar
function moveElement(target, destination, prepend, parent, keepTrying, callback) {
    parent = parent ? parent : document;
    var objectToMoveFrom = target instanceof HTMLElement ? target : parent.querySelector(target);
    var objectToMoveTo = destination instanceof HTMLElement ? destination : parent.querySelector(destination);
    if (objectToMoveFrom && objectToMoveTo) {
        prepend ? objectToMoveTo.insertAdjacentElement("afterbegin", objectToMoveFrom) : objectToMoveTo.insertAdjacentElement("beforeend", objectToMoveFrom);
        callback && callback();
        return true;
    } else {
        if (keepTrying) {
            setTimeout(function() {
                moveElement(target, destination, prepend, parent, keepTrying, callback);
            }, 100);
        }
        return false;
    }
}
